<template>
    <div>
        <v-header @touchmove.prevent ></v-header>
        <v-goods></v-goods>
    </div>
</template>

<script>
    import header from '../components/Header';
    import goods from '../components/GoodsShow';

    export default {
        name:'GoodsMainShow',
        inject: ['reload'],
        data() {
            return {
                seller: {},
                tableOrderInfo: {},
            }
        },
        created() {
        },
        methods: {
      
            getPath() {
                //if (this.$route.path == '/buffet') {
                //    this.getRestaurantInfo();
                //}
            }
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            'v-header': header,
            'v-goods': goods
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/GoodsMainShow.vue